import { createSlice } from "@reduxjs/toolkit";
import { apiConfigState, TemplateConfig } from "./type";

const initialState: apiConfigState = {
  service_templates: [],
  provider_master_list: null,
  provider_master_options: [],
  provider_service_list: { total: 0, page: 1, page_size: 10, data: [] },
  provider_service_options: [],
};

const apiConfigSlice = createSlice({
  name: "apiConfig",
  initialState,
  reducers: {
    serviceTemplates: (state, action: { payload: apiConfigState["service_templates"] }) => {
      state.service_templates = action.payload;
    },
    addServiceTemplate: (state, action: { payload: TemplateConfig }) => {
      state.service_templates.push(action.payload);
    },
    updateServiceTemplate(
      state,
      action: {
        payload: {
          id: number;
          data: Partial<TemplateConfig>;
        };
      }
    ) {
      const index = state.service_templates.findIndex(
        (template) => template.id === action.payload.id
      );
      console.log("payload", action.payload, index);

      if (index !== -1) {
        state.service_templates[index] = {
          ...state.service_templates[index],
          ...action.payload?.data,
        };
      }
    },
    deleteServiceTemplate(state, action: { payload: number }) {
      state.service_templates = state.service_templates.filter(
        (template) => template.id !== action.payload
      );
    },
    providerMasterList: (state, action: { payload: apiConfigState["provider_master_list"] }) => {
      state.provider_master_list = action.payload;
      state.provider_master_options = action.payload.data?.map((provider) => ({
        label: provider.name,
        value: provider.id,
      }));
    },
    providerServiceList: (state, action: { payload: apiConfigState["provider_service_list"] }) => {
      state.provider_service_list = action.payload;
      state.provider_service_options = action.payload.data?.map((service) => ({
        label: service.name,
        value: service.id,
      }));
    },
    updateProviderService(state, action: { payload: { id: number; data: any } }) {
      const index = state.provider_service_list.data.findIndex(
        (service) => service.id === action.payload.id
      );
      console.log("INDEX", index);

      if (index !== -1) {
        state.provider_service_list.data[index] = {
          ...state.provider_service_list.data[index],
          ...action.payload.data,
        };
        state.provider_service_options = state.provider_service_list.data.map((service) => ({
          label: service.name,
          value: service.id,
        }));
      }
    },
    createProviderService(state, action: { payload: any }) {
      state.provider_service_list.data.unshift(action.payload);
      state.provider_service_list.total += 1;
      state.provider_service_options = state.provider_service_list.data.map((service) => ({
        label: service.name,
        value: service.id,
      }));
    },
    deleteProviderService(state, action: { payload: number }) {
      state.provider_service_list.data = state.provider_service_list.data.filter(
        (service) => service.id !== action.payload
      );
      state.provider_service_list.total -= 1;
      state.provider_service_options = state.provider_service_list.data.map((service) => ({
        label: service.name,
        value: service.id,
      }));
    },
  },
});

export const {
  serviceTemplates,
  addServiceTemplate,
  updateServiceTemplate,
  deleteServiceTemplate,
  providerMasterList,
  providerServiceList,
  updateProviderService,
  createProviderService,
  deleteProviderService,
} = apiConfigSlice.actions;
export default apiConfigSlice.reducer;

// ci test
